module.exports = __webpack_public_path__ + "static/media/018.5c1ee03c.jpg";